import { Component, OnInit } from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { Router } from '@angular/router';
import { OtherService } from 'src/app/Service/other.service';
import { MapService } from 'src/app/Service/map.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { DataService } from 'src/app/Service/data.service';
import { BingMaps, XYZ } from 'ol/source';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
declare let $: any;

@Component({
  selector: 'app-location-timeline',
  templateUrl: './location-timeline.component.html',
  styleUrls: ['./location-timeline.component.css']
})

export class LocationTimelineComponent implements OnInit {
  map: any = {};
  showInfo: boolean = true;
  source: any;
  vector: any;
  draw: any;
  tooltipData: any;
  location: any;
  selectedItem: any;
  layers: any = [];
  allCar: any = [];
  allCar_Temp: any;
  car: any;

  private bOfflineMap: boolean = (<any>window).bOfflineMap;
  private strMapUrl: string = (<any>window).strMapUrl;

  mdl_Search: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),
    strDate: new FormControl("", Validators.required),
    strTime: new FormControl("", Validators.required),
  });

  constructor(
    private _tooltip: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private formBuilder: FormBuilder,
    private mapService: MapService,
    private gurdService: GurdServiceService,
    private dataService: DataService,
  ) { }

  ngOnInit(): void {

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    })

    this.newOpenMap();

  }

  ngAfterViewInit() {

    setTimeout(() => {

      this.map.on('pointermove', (e: any) => {

        if (e.dragging) {

          //...

          return;
        }

        var el = this.mapService.mapPointerMove(this.map.getEventPixel(e.originalEvent), this.map);

        //Handel cursor

        var pixel = this.map.getEventPixel(e.originalEvent);

        var hit = this.map.hasFeatureAtPixel(pixel);

        this.map.getViewport().style.cursor = hit ? 'pointer' : '';

        this.showData(el, true);

      });

      this.map.on('click', (e: any) => {

        if (e.dragging) {

          //...

          return;

        }

        var el = this.mapService.mapPointerMove(this.map.getEventPixel(e.originalEvent), this.map);

        this.showData(el);

        $('#link').click(() => {

          var tooltip = $('#map_tooltip');

          tooltip.tooltip('hide');

        });

      });

      this.map.getView().on('propertychange', (e: any) => {

        var tooltip = $('#map_tooltip');

        tooltip.tooltip('hide');

        this.tooltipData = null;

      });

    }, 500);

  }

  newOpenMap() {

    this.source = new VectorSource({ wrapX: false });

    this.vector = new VectorLayer({ source: this.source });

    if (this.bOfflineMap) {

      this.layers.push(

        new TileLayer({

          source: new XYZ({

            // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

            url: this.strMapUrl,

            attributions: 'Map data © RayanAndishehNasr' // 

          }),

        })

      );

    }

    else {

      const styles = ['AerialWithLabelsOnDemand'];

      let i, ii;

      for (i = 0, ii = styles.length; i < ii; ++i) {

        this.layers.push(

          new TileLayer({

            visible: false,

            preload: Infinity,

            source: new BingMaps({

              key: 'AnyK3Znr5dGRC7QqdZpTT3vbxpdcxPWB5ehWfJYf9k1Iq-b-jZrYKiX1NkSLKNi-',

              imagerySet: styles[i],

            }),

          }),

        );

      }

      this.layers.push(new TileLayer({

        visible: true,

        source: new OSM({}),

      }), this.vector)

    }

    this.map = new Map({

      layers: this.layers,

      target: 'timeline_map',

      view: new View({

        center: olProj.fromLonLat([51.3833554, 35.6770113]),

        zoom: 13,

      }),

    });

  }

  async search_Timeline() {

    if (this.allCar) {

      this.mapService.removeLayerByName("car", this.map);

    }

    this.mdl_Search.get('strTime')?.setValue($("#Stime").val())

    if (this.mdl_Search.invalid) return this._tooltip.showError('تاریخ و ساعت را مشخص کنید')

    this.otherService.Showspinner();

    const resp = await axios.post(`FleetYar_Car_ListAtTime`, this.otherService.stringNumberToNumber(this.mdl_Search.value));

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x123s3dw310' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this.allCar = res;

    this.allCar_Temp = res;

    this.carfun(res);

  }

  async carfun(data: any, fit?: boolean) {

    var resp = {} as any;

    resp.data = data;

    if (resp.data[0] && resp.data[0].ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '105s' } });


    }

    if (resp.data == null) {

      return this._tooltip.showError('بروز خطا در سامانه');

    }

    else {

      this.car = resp.data;

      if (this.car.length == 1 && this.car[0].bIncomplete == true) {

        return this.router.navigate([`/entryCar/1/${this.car[0]?.strUnitId ? this.car[0].strUnitId : this.car[0].strUnitID}`]);

      }

      //Craete Marker

      if (this.car.length != 0) {

        // resp.data.forEach((element: any, index: number) => {

        for (let index = 0; index < resp.data.length; index++) {

          if (resp.data[index].fLon != 0 && resp.data[index].fLat != 0) {

            //? ترسیم ایکن خودرو توسط تصویر base64

            // var marker = this.mapService.createMarker([resp.data[index].fLon, resp.data[index].fLat], 'data:image/jpeg;base64,' + resp.data[index].strMobileIcon, `${index}`, `car`, {

            // Id: resp.data[index].strUnitId,

            //? ترسیم ایکن خودرو توسط نام ارسالی از سرور

            var marker = this.mapService.createMarker([resp.data[index].fLon, resp.data[index].fLat], `../../../assets/mobile-icons/${resp.data[index].strIconName}`, `${index}`, `car`, {

              Id: resp.data[index].strUnitID,

              html: `<div id="" class="pointer">

                        <h5 class='text-dark'>${resp.data[index].strFullName} (${resp.data[index].strMobileType_strComment}) </h5>

                        <hr class='text-dark m-1' />

                        <div class='justify-content-end d-flex align-items-center'>

                            <span class=" text-secondary ms-1"> ${resp.data[index].fLastKM.toLocaleString()} کیلو متر </span>

                            <i class="fa fa-tachometer text-secondary "></i>

                        </div>

                        <div class='justify-content-end d-flex align-items-center'>

                            <span class=" text-secondary ms-1">${resp.data[index].strVehicleNo}</span>

                            <i class="fa fa-square-o text-secondary "></i>

                        </div>

                        <div class='justify-content-end d-flex align-items-center'>

                            <span class=" text-secondary ms-1">${resp.data[index].strTime}</span>

                            <i class="fa fa-clock-o text-secondary "></i>

                        </div>

                        <div class='justify-content-end d-flex align-items-center'>

                            <span class=" text-secondary ms-1">${resp.data[index].strDate}</span>

                            <i class="fa fa-calendar-o text-secondary "></i>

                        </div>

                        <div class='justify-content-end d-flex align-items-center'>

                            <span class=" text-secondary ms-1">${resp.data[index].strDeviceStatus_strComment}</span>

                            <i class="fa fa-key text-secondary "></i>

                        </div>

                        <a class='btn btn-info w-100' id='map-button'>جزییات کامل </a>

                    </div>`,

              html2: `<div id="map-tooltips">

                         <h5 class='text-dark'>

                            ${resp.data[index].strFullName} (${resp.data[index].strMobileType_strComment})

                         </h5>

                      </div>`,
            });

            this.map.addLayer(marker);

          }

          // });
        };

        //Handel fit content Map

        if (fit != false) {

          this.fitMap(resp.data)

        }

      }

    }

  }

  showData(item: any, hover?: any) {

    var tooltip: any;

    if (!hover) tooltip = $('#map_tooltip');

    else tooltip = $('#map_tooltips');

    tooltip.tooltip({

      html: true,

      animation: true,

      trigger: 'manual',

      placement: 'top',

    });

    tooltip.css({

      left: item.pixel[0] + 'px',

      top: item.pixel[1] - 14 + 'px',

      zindex: 1000,

    });

    if (item.featureLayer) {

      if (item.featureLayer.feature.get('data')) {

        if (!hover) {

          this.tooltipData = item.featureLayer.feature.get('data').html;

          tooltip.attr('data-bs-original-title', item.featureLayer.feature.get('data').html).tooltip('show');

          var hoverTooltip = $('#map_tooltips');

          hoverTooltip.tooltip('hide');

        }

        else {

          if (this.tooltipData == item.featureLayer.feature.get('data').html) { }

          else {

            tooltip.attr('data-bs-original-title', item.featureLayer.feature.get('data').html2).tooltip('show');

          }

        }

        $('#map-button').off('click').on('click', () => {

          window.open(`carInfo/${item.featureLayer.feature.get('data').Id}`,'_blank');

          tooltip.tooltip('hide');

          var hoverTooltip = $('#map_tooltip');

          hoverTooltip.tooltip('hide');

        });

      }

    }

    else {

      tooltip.tooltip('hide');

      this.tooltipData = null;

    }

  }

  filter(val: any) {

    if (val.value.length > 1) {

      this.mapService.removeLayerByName("car", this.map);

      this.allCar = this.allCar_Temp?.filter((el: any) => {

        return el.strFullName.includes(val?.value) || el.strMobile.includes(val?.value);


      });

      this.carfun(this.allCar)

    }

    if (val.value.length == 0) {

      this.allCar = this.allCar_Temp;

      this.mapService.removeLayerByName("car", this.map);

      this.carfun(this.allCar)


    }

  }

  fitMap(data?: any) {

    if (data == null) {

      data = this.car;

    }

    this.mapService.fitMap(data, this.map);

    if (data.length == 1) {

      this.map.getView().setZoom(17);

    }

  }

  focusOnCar(data) {

    if (data.fLon != 0 && data.fLat != 0) {

      var view = this.map.getView();

      view.animate({

        zoom: 20,

        center: olProj.transform([data.fLon, data.fLat], 'EPSG:4326', 'EPSG:3857'),

      });

      setTimeout(() => {

        var coordinates = olProj.transform(

          [data.fLon, data.fLat],

          'EPSG:4326',

          'EPSG:3857'

        );

        var pix = this.map.getPixelFromCoordinate(coordinates);

        var el = this.mapService.mapPointerMove(

          [pix[0] + 18, pix[1] - 27.5],

          this.map

        );

        this.showData(el);

      }, 1200);


    }

  }


}
